var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsOutput = function SvgArrowsOutput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 15v-4.853h1.324v2.6L4.279 9.79l.93.93-2.956 2.956h2.6V15zm10.147 0v-1.323h2.6L9.79 10.72l.93-.93 2.956 2.956v-2.6H15V15zM4.28 5.21 1.324 2.252v2.6H0V0h4.853v1.324h-2.6L5.21 4.279zm6.442 0-.93-.93 2.956-2.956h-2.6V0H15v4.853h-1.323v-2.6zM7.5 8.967q-.606 0-1.037-.431a1.41 1.41 0 0 1-.43-1.037q0-.606.43-1.037a1.41 1.41 0 0 1 1.037-.43q.606 0 1.037.43.43.431.43 1.037t-.43 1.037a1.41 1.41 0 0 1-1.037.43"
  })));
};
export default SvgArrowsOutput;